var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      attrs: { id: "custom-fields-form-container", autocomplete: "off" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          $event.stopPropagation()
        },
      },
    },
    [
      _vm.validCustomFields.length
        ? [
            _c("p", { staticClass: "bold mb-1" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("custom-fields.customFieldsWithDefinition")) +
                  "\n    "
              ),
            ]),
            _vm._v(" "),
            _c(
              "draggable",
              {
                staticClass: "sortable-collapse",
                attrs: {
                  id: "custom-fields-draggable-container",
                  tag: "div",
                  animation: 200,
                  draggable: ".sortable",
                  "ghost-class": "ghost",
                  handle: ".sortable-handle",
                },
                model: {
                  value: _vm.validCustomFields,
                  callback: function ($$v) {
                    _vm.validCustomFields = $$v
                  },
                  expression: "validCustomFields",
                },
              },
              _vm._l(_vm.validCustomFields, function (field) {
                return _c(
                  "div",
                  {
                    key: field.id,
                    class: { sortable: !_vm.isSystemField(field.id) },
                  },
                  [
                    _c("custom-field-control-buttons", {
                      attrs: {
                        "allow-edit": !_vm.isSystemField(field.id),
                        "allow-delete": !_vm.isSystemField(field.id),
                        "allow-order": !_vm.isSystemField(field.id),
                        "allow-visibility": _vm.allowVisibility,
                        "visibility-type": _vm.getFieldVisibility(field.id),
                      },
                      on: {
                        edit: function ($event) {
                          return _vm.handleEdit(field.id)
                        },
                        delete: function ($event) {
                          return _vm.handleDelete(field.id, "definition")
                        },
                        visibility: function ($event) {
                          return _vm.handleVisibilityChange(field.id)
                        },
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "custom-field",
                            fn: function () {
                              return [
                                _c("custom-field-definition", {
                                  attrs: {
                                    editable: false,
                                    name: field.name,
                                    type: field.type,
                                  },
                                }),
                              ]
                            },
                            proxy: true,
                          },
                          {
                            key: "delete-confirmation",
                            fn: function () {
                              return [
                                _c("div", { staticClass: "text-gray mb-2" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t(
                                          "custom-fields.messages.deleteFieldsWarn.removedFromAll",
                                          {
                                            element: _vm.getElementName(),
                                            container: _vm.getContainerName(),
                                          }
                                        )
                                      ) +
                                      "\n              "
                                  ),
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "custom-fields.messages.deleteFieldsWarn.ifAnyValue"
                                        )
                                      )
                                    ),
                                  ]),
                                  _vm._v(
                                    ",\n              " +
                                      _vm._s(
                                        _vm.$t(
                                          "custom-fields.messages.deleteFieldsWarn.movedToDeleted"
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                  ],
                  1
                )
              }),
              0
            ),
          ]
        : _c(
            "div",
            { staticClass: "d-flex flex-column align-items-center" },
            [
              _c(
                "no-results",
                {
                  attrs: {
                    "img-src": require("@Broker/@Assets/icon/empty-timeline.png"),
                  },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$t("custom-fields.messages.noEditableCustomFields")
                      ) +
                      "\n    "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "simple-button",
                {
                  attrs: { "class-name": "ml-2 btn-sm", type: "primary" },
                  on: { click: _vm.handleCreate },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("client-profile.actions.createOne")) +
                      "\n    "
                  ),
                ]
              ),
            ],
            1
          ),
      _vm._v(" "),
      _vm.orphanCustomFields.length
        ? [
            _c("hr"),
            _vm._v(" "),
            _c("p", { staticClass: "bold mb-1" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("global.doorr.deletedFields")) +
                  "\n    "
              ),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "small mb-0" }, [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t(
                      "custom-fields.messages.deletedFields.previouslyCreatedFields",
                      {
                        element: _vm.getElementName(),
                      }
                    )
                  ) +
                  "\n    "
              ),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "small" }, [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t(
                      "custom-fields.messages.deletedFields.permanentlyRemoved",
                      {
                        element: _vm.getElementName(),
                      }
                    )
                  ) +
                  "\n    "
              ),
            ]),
            _vm._v(" "),
            _vm._l(_vm.orphanCustomFields, function (field) {
              return _c(
                "div",
                { key: field.id, staticClass: "row no-gutters" },
                [
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c("custom-field-definition", {
                        attrs: {
                          editable: false,
                          name: field.name,
                          type: field.type,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("custom-field-control-buttons", {
                    attrs: {
                      "delete-confirmation": _vm.$t(
                        "custom-fields.actions.deleteField"
                      ),
                      "allow-edit": false,
                      "allow-visibility": false,
                      "allow-order": false,
                    },
                    on: {
                      delete: function ($event) {
                        return _vm.handleDelete(field.id, "orphan")
                      },
                    },
                  }),
                ],
                1
              )
            }),
          ]
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex flex-row justify-content-end mt-2" },
        [
          _vm.validCustomFields.length || _vm.orphanCustomFields.length
            ? _c(
                "simple-button",
                {
                  attrs: { "class-name": "ml-2", type: "primary" },
                  on: { click: _vm.handleCancel },
                },
                [
                  _vm._v(
                    "\n      " + _vm._s(_vm.$t("global.words.done")) + "\n    "
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }